import React, { useEffect, useState } from 'react';
import styles from './GeneralCalendar.module.scss';
import Button from '../../../atoms/button/Button';
import Text from '../../../../components/atoms/text/Text';
import EventCalendar from '../../../atoms/eventCalendar/EventCalendar';
import CalendarUI from '../../../organism/calendar/Calendar';
import CalendarTable from '../../../molecule/calendarTable/CalendarTable';
import DownloadButton from '../../../atoms/downloadButton/DownloadButton';
import Loader from '../../../atoms/loader/Loader';
import { useTranslation } from 'react-i18next';
import endpoints from '../../../../api/endpoints';
import { useMediaQuery } from 'react-responsive';
const historySvg = '/icons/history/history-circle.svg';
// import CalendarDropdown from './components/CalendarDropdown';
import ComingSoonContainer from '../../CommingSoon/ComingSoonContainer';
import useIsRtl from '../../../../app/helpers/isRtl';
import { useNavigate } from 'react-router-dom';

const TabButton = ({ title, isActive, onClick, isHomePage, isRtl }) => (
  <div
    className={`${isActive ? styles.activeTabButton : styles.tabButton} ${isHomePage ? styles['remove-borders'] : ''}`}
    onClick={onClick}
  >
    <Text
      title={title}
      variant="text-bold-italic-20-black"
      color={isHomePage && 'white'}
      style={{ cursor: 'pointer' }}
    />
    {isHomePage ? null : <div className={isActive ? styles.line : ''}></div>}
  </div>
);

const SubTabs = ({ subActive, setSubActive, isHomePage, isMobileOrTablet }) => {
  const tabs = [
    'academic_calendar.yearly',
    'academic_calendar.monthly',
    'academic_calendar.list',
  ];

  const visibleTabs = isHomePage && isMobileOrTablet ? [] : tabs;
  return (
    <div className={styles.actions}>
      {visibleTabs.map((title, index) => {
        const actualIndex = tabs.indexOf(title);
        return (
          <Button
            key={title}
            title={title}
            styleType="black"
            variant="text-regular-16"
            onClick={() => setSubActive(actualIndex)}
            className={subActive === actualIndex ? styles.button : ''}
          />
        );
      })}
    </div>
  );
};
const formatEventData = (events) => {
  return events.map((event) => ({
    ...event,
    startDate: new Date(event.fromDate),
    endDate: new Date(event.endDate),
  }));
};

const ContentArea = ({ subActive, dataTable, isHomePage, isRtl }) => {
  return (
    <div className={isHomePage ? styles.smallFont : ''}>
      {subActive === 0 && (
        <div
          className={`${styles.grid} ${isHomePage ? styles.homeGrid : ''}`}
          dir={isRtl ? 'rtl' : ''}
        >
          {dataTable.map((monthEvents, index) => (
            <div key={index} className={styles['grid-item']}>
              <EventCalendar
                events={formatEventData(monthEvents.calendarDays)}
                MonthYearText={monthEvents.monthYear}
                month={monthEvents.monthInt}
                year={monthEvents.yearInt}
              />
            </div>
          ))}
        </div>
      )}
      {subActive === 1 && <CalendarUI data={dataTable} />}
      {subActive === 2 && (
        <>
          <CalendarTable data={dataTable} isHomePage={isHomePage} />
        </>
      )}
    </div>
  );
};
const GeneralCalendar = ({
  id,
  activeYearId,
  events,
  myEventsList,
  dataTable,
  isLoading,
  tabs,
  setActiveYearId,
  isHomePage,
  externalTabs,
}) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [subActive, setSubActive] = useState(0);
  const hasData = dataTable && dataTable.length > 0;
  const { t, i18n } = useTranslation();
  const currenLanguage = i18n.language;
  const isEnglish = currenLanguage === 'en';
  const isMobileOrTablet = useMediaQuery({ maxWidth: 1200 });
  const isRtl = useIsRtl();
  useEffect(() => {
    if (isHomePage && isMobileOrTablet) {
      setSubActive(2);
    }
  }, [isHomePage, isMobileOrTablet]);
  const isComingSoon = !isLoading && !hasData;
  useEffect(() => {
    if (tabs?.length > 1) {
      setActiveYearId(tabs[1].apiId);
    }
  }, []);
  return (
    <div className={styles.calendar} style={{ direction: 'ltr' }}>
      <div
        className={`${styles.header} ${isHomePage ? styles['homepage-header'] : ''}`}
      >
        {(isRtl ? tabs.slice().reverse() : tabs).map((tab) => (
          <TabButton
            key={tab.id}
            title={tab.title}
            isActive={activeTab === tab.id}
            onClick={() => {
              setActiveTab(tab.id);
              setActiveYearId(tab.apiId);
            }}
            isHomePage={isHomePage}
            isRtl={isRtl}
          />
        ))}
      </div>
      <div className={`${isHomePage ? styles['homepage-container'] : ''}`}>
        <div
          className={`${styles.body} ${
            isHomePage
              ? isComingSoon
                ? styles.unsetBackground
                : styles.bodyHomePage
              : ''
          } ${!hasData ? styles['remove-padding'] : ''}`}
          onMouseEnter={
            !hasData && isHomePage
              ? () => (window.isHoveringCalendar = false)
              : () => (window.isHoveringCalendar = true)
          }
          onMouseLeave={
            !hasData && isHomePage
              ? () => (window.isHoveringCalendar = false)
              : () => (window.isHoveringCalendar = false)
          }
        >
          <div
            className={styles.step}
            style={{
              gap: isHomePage ? '20px' : '',
            }}
          >
            {isLoading ? (
              <Loader
                fullPage={!isHomePage}
                containerStyle={isHomePage ? styles.loaderContainer : ''}
              />
            ) : hasData ? (
              <>
                {isHomePage && isMobileOrTablet ? null : (
                  <div
                    className={styles.title}
                    style={{ minHeight: isHomePage ? '10px' : '' }}
                  >
                    {!isHomePage ? (
                      <div className={styles.text}>
                        <DownloadButton
                          title={t('common.Download_Brochure')}
                          variant="text-bold-italic-16-black"
                          className={styles.buttonClass}
                          to={`${endpoints.baseUrl}${endpoints.downloadBroshure}${id}/${activeYearId}`}
                          isLink
                          textColor={isHomePage ? 'white' : 'black'}
                          svgColor={!isHomePage ? 'brightness(0)' : ''}
                        />{' '}
                      </div>
                    ) : (
                      externalTabs
                    )}

                    {!isHomePage ? (
                      <SubTabs
                        subActive={subActive}
                        setSubActive={setSubActive}
                        isHomePage={isHomePage}
                        isMobileOrTablet={isMobileOrTablet}
                      />
                    ) : null}
                  </div>
                )}
                <ContentArea
                  subActive={subActive}
                  events={events}
                  myEventsList={myEventsList}
                  dataTable={dataTable}
                  key={dataTable}
                  isHomePage={isHomePage}
                  isRtl={isRtl}
                />
              </>
            ) : isHomePage ? (
              <div className={styles['comingSoon-svg']}>
                <div
                  className={`${styles['empty-tabs']} ${styles['rtl-tabs']}`}
                >
                  {externalTabs}
                </div>
                <div className={styles['text-container']}>
                  <img src={historySvg} />

                  <Text
                    title={isEnglish ? 'Coming Soon' : 'common.soon'}
                    variant="text-regular-bold-20"
                    className={styles.comingSoonText}
                  />
                </div>
              </div>
            ) : (
              <div
                className={`${styles.comingSoon} ${isHomePage ? styles.homepageComingSoon : ''}`}
              >
                <ComingSoonContainer isGreen contStyle={{ height: 'auto' }} />
              </div>
            )}
          </div>
        </div>
      </div>
      {isHomePage ? (
        <Button
          title={t('common.Download_Brochure')}
          variant="text-regular-20"
          style={{ textTransform: 'uppercase' }}
          styleType="primary"
          className={styles['view-all-button']}
          svgPosition="right"
          onClick={() => navigate('/academic-calendar')}
        />
      ) : null}
    </div>
  );
};

export default GeneralCalendar;
